// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  projectName: "iotCore",
  
  // API Links
  IDENTITY_LINK: `https://api-gsx.onstak.ai/services/digital-twin`,
  CORE_LINK: `https://api-gsx.onstak.ai/services/digital-twin`,
  CORE_LINK_cdn: `http://dev.leapfrogiot.com/services/iot-platform`,
  SOCKET_LINK: `https://api.onstak.io`,
  MQTT_LINK: `http://event-hub.onstak.io`,
  AI_ASSITANCE_LINK: `https://api-gsx.onstak.ai/services/ai-assistant/ask`,

  // Authentication Endpoints
  auth: {
    authenticate: `/api/v2/accounts/user/authentication`,
    userExists: `/api/accounts/manage/user/exist`,
    recover: "/api/v2/accounts/user/forget-password",
    reset: "/api/v2/accounts/user/reset-password",
  },

  // Dashboard Endpoints
  dash: {
    dashboard: `/api/v1/dashboards/`,
    workspace: `/api/v2/workspaces`,
    userExists: `/api/accounts/user/exists`,
    userDetails: `/api/accounts/user/details`,
    sheetsQuery: `/api/v2/sheets/query`,
    v1Sheets: `/api/v1/sheets`,
    v2Sheets: `/api/v2/sheets`,
    widgetsQuery: `/api/v2/widgets/query`,
    widgets: `/api/v2/widgets`,
    bookmarks: `/api/v1/dashboards/bookmarks`,
  },



  // Plugins Configuration
  pluginsMaxNumberOfRecords: 20,
  
  // Socket Configuration
  socketUrlPath: "/services/streams",
  socketThingSubscribePath: "streams/device/subscribe",
  socketThingListenPath: "streams/telemetry/",

  // Google Maps API Key
  GOOGLE_MAPS_API_KEY: "AIzaSyDTAnbYHkvbKFbYmWr10P918lcgqpwpDtk",
};
